/*******************************************************
Calculate Dropdown Menu Position
Figure out where the dropdown menu should be appear (and if it should left or right aligned).

Figuring out when to close/position the menu is complicated because the sub nav is not a
child element of the selected item. That's how it's normally done, but it wasn't an option
due to the flexbox wrap menu for the visible navigation row (.s-nav) The required overflow: hidden
setting in the visible nav row would clip the dropdown if it was a child of a visible nav item
********************************************************/

// Figure out where the dropdown menu should be appear (and if it should left or right aligned)
export default function calculateDropdownPosition($selectedItem) {

    // Find the sub navgations
    let $selectedSubNav = $(`.s-sub-nav__group[data-item="${$selectedItem.data('name')}"]`);
    if ($selectedSubNav.length === 0) {
        $selectedSubNav = $(`.section-sub-nav__group[data-item="${$selectedItem.data('name')}"]`);
    }

    // Get the left side position of the selected item
    const itemLeftSide = $selectedItem.position().left;

    // There's a transparent border on the sub nav groups so that moving the mouse outside the
    // dropdown is more forgiving. This border needs to be accounted for when calculating the menu position
    const transparentBorderOffset = parseInt($selectedSubNav.css('border-left-width'), 10);

    // Get the width of the sub nav group
    const subNavWidth = parseInt($selectedSubNav.css('width'), 10);

    // Get the width of the selected item
    const itemWidth = parseInt($selectedItem.css('width'), 10);

    // Get the width of the navigation row (the page width)
    let pageWidth = parseInt($('.s-sub-nav').css('width'), 10);
    if ($('.s-sub-nav').length === 0) {
        pageWidth = parseInt($('.section-sub-nav').css('width'), 10);
    }

    // Calculate where the sub nav should be positioned for right alignment
    const rightAlignPosition = (itemLeftSide + transparentBorderOffset + itemWidth) - subNavWidth;

    // Check if left-aligning the menu will make it overflow the right side of the page
    const overflowsRightSideOfPage = ((itemLeftSide + subNavWidth) > pageWidth);

    // Align the sub menu on the left unless that would make it extend past the boundaries of the right side of the page
    let menuPosition = overflowsRightSideOfPage ? rightAlignPosition : itemLeftSide - transparentBorderOffset;

    if (subNavWidth === pageWidth) { menuPosition = 0; }

    return menuPosition;
}
